import React, { useMemo } from "react";
import { useFetchAssets } from "../../../../../hooks";
import { AccordionAssetsForATriaName } from "../../../../rx.core";
import HomeCrypto from "../../components/LoadersPages/HomeCrypto";
import { Accordion } from "./Accordion";

export const CryptoLite: React.FC = () => {
  const { allAssets, isLoading, isError, error, refetch } = useFetchAssets();

  // const fromAssets = useSelector((store: RootState) => store.User?.userAssets);

  const groupedAssets = useMemo(() => {
    const updatedGroupedAssets: {
      [key: string]: AccordionAssetsForATriaName[];
    } = {};
    allAssets.forEach((asset) => {
      // Define a unique identifier based on asset characteristics
      const assetIdentifier = `${asset?.name}-${asset?.symbol}-${asset?.chainName}-${asset?.tokenAddress}`;

      // Check if this specific asset variant already exists
      const existingAssetIndex = updatedGroupedAssets[asset?.name]?.findIndex(
        (a) =>
          `${a?.name}-${a?.symbol}-${a?.chainName}-${a?.tokenAddress}` ===
          assetIdentifier
      );

      if (
        existingAssetIndex !== undefined &&
        existingAssetIndex > -1 &&
        updatedGroupedAssets &&
        updatedGroupedAssets[asset.name]
      ) {
        const item = updatedGroupedAssets[asset.name]?.[existingAssetIndex];
        if (item) {
          // If found, sum the balances
          item.aabalanceInTokens +=
            asset?.wallet?.type === "AA" ? asset?.balanceInTokens : 0;
          item.eoabalanceInTokens +=
            asset?.wallet?.type === "EOA" ? asset?.balanceInTokens : 0;
          item.eoabalanceInUSD +=
            asset?.wallet?.type === "EOA" ? asset?.balanceInUSD : 0;
          item.aabalanceInUSD +=
            asset?.wallet?.type === "AA" ? asset?.balanceInUSD : 0;
          item.balanceInUsd += asset.balanceInUSD;
        }
      } else {
        // If not found, initialize array if necessary and push new asset
        if (!updatedGroupedAssets[asset.name]) {
          updatedGroupedAssets[asset.name] = [];
        }

        const newAsset: AccordionAssetsForATriaName = {
          name: asset?.name,
          symbol: asset?.symbol,
          logoUrl: asset?.logoUrl,
          chainLogo: asset?.chainLogo,
          chainName: asset?.chainName,
          balanceOfTokensInUnits: asset?.balanceOfTokensInUnits,
          decimals: asset?.decimals,
          aabalanceInTokens:
            asset?.wallet?.type === "AA" ? asset?.balanceInTokens : 0,
          eoabalanceInTokens:
            asset?.wallet?.type === "EOA" || !asset?.wallet?.type
              ? asset?.balanceInTokens
              : 0,
          eoabalanceInUSD:
            asset?.wallet?.type === "EOA" || !asset?.wallet?.type
              ? asset?.balanceInUSD
              : 0,
          aabalanceInUSD:
            asset?.wallet?.type === "AA" ? asset?.balanceInUSD : 0,
          quoteRate: asset?.quoteRate,
          tokenAddress: asset?.tokenAddress,
          percentChangein24hr: asset?.percentChangein24hr,
          isCustomToken: asset?.isCustomToken,
          balanceInUsd: asset.balanceInUSD,
        };
        console.log(newAsset);
        updatedGroupedAssets[asset.name]?.push(newAsset);
      }
    });

    return Object.keys(updatedGroupedAssets)
      .map((el) => ({
        group: el,
        assets: updatedGroupedAssets[el].sort(
          (a, b) => b.balanceInUsd - a.balanceInUsd
        ),
        balanceInUsd: updatedGroupedAssets[el].reduce(
          (total: number, item) =>
            total +
            parseFloat(String(item?.eoabalanceInUSD ?? 0)) +
            parseFloat(String(item?.aabalanceInUSD ?? 0)),
          0
        ),
        balanceInToken: updatedGroupedAssets[el].reduce(
          (total: any, item: any) =>
            total +
            parseFloat(item?.eoabalanceInTokens + item?.aabalanceInTokens),
          0
        ),
      }))
      .sort((a, b) => b.balanceInUsd - a.balanceInUsd);
  }, [allAssets]);

  return (
    <div className="h-full flex flex-col">
      {allAssets.length === 0 && isLoading && <HomeCrypto responsive />}
      {allAssets.length > 0 && (
        <div className="flex-1 overflow-y-auto">
          <div className="w-full">
            <Accordion groupedAssets={groupedAssets} lite={true} />
          </div>
        </div>
      )}
      {!isLoading && !Object.keys(groupedAssets)?.length && (
        <div className="flex-1 flex flex-col items-center justify-center gap-[1.4vh]">
          <img
            src="./images/nocryptodark.svg"
            className="w-[17.85vh] h-[17.85vh]"
            alt="nocryptodark"
          />
          <p className="font-[600] text-[1.4vh] text-fontLightColor dark:text-fontLightColorDark">
            You have no crypto right now
          </p>
        </div>
      )}
    </div>
  );
};
